import { BRAND } from "@/data/mockData";

export default function StickyWhatsApp() {
  const href = `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent("Hello SIRIJA, I'd like to enquire about your silver jewellery.")}`;
  return (
    <a
      data-testid="sticky-whatsapp-btn"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed z-40 bottom-6 right-6 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(37,211,102,0.55)] hover:scale-105 transition-transform"
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.55c-.28-.14-1.66-.82-1.92-.91-.26-.09-.45-.14-.63.14-.19.28-.72.91-.88 1.1-.16.19-.32.21-.6.07-.28-.14-1.19-.44-2.27-1.4-.84-.75-1.4-1.68-1.57-1.96-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.63-1.51-.86-2.07-.23-.55-.46-.47-.63-.48l-.54-.01c-.19 0-.49.07-.75.35-.26.28-.98.96-.98 2.33 0 1.37 1 2.7 1.14 2.89.14.19 1.98 3.02 4.79 4.24 1.88.81 2.05.63 2.42.6.37-.04 1.19-.49 1.36-.96.17-.47.17-.87.12-.96-.05-.09-.19-.14-.47-.28zM16.02 3.2C9 3.2 3.3 8.9 3.3 15.92c0 2.24.59 4.42 1.71 6.35L3 29l6.87-1.99a12.7 12.7 0 0 0 6.13 1.55h.01c7.02 0 12.72-5.71 12.72-12.72S23.03 3.2 16.02 3.2zm0 23.03h-.01a10.62 10.62 0 0 1-5.4-1.48l-.39-.23-4.07 1.18 1.19-3.97-.25-.4a10.55 10.55 0 0 1-1.62-5.61c0-5.83 4.75-10.57 10.57-10.57 2.82 0 5.47 1.1 7.47 3.1a10.5 10.5 0 0 1 3.09 7.48c0 5.83-4.74 10.57-10.58 10.57z"/>
      </svg>
    </a>
  );
}
